<template>
	<div class="monthSelector" v-if="selectedSlotKey">
		<v-slide-group
			ref="monthSlideGroup"
			:center-active="true" 
			class="monthSlider"
			v-model="selectedSlotKey"
			@update:model-value="onSlideGroupUpdate"
			@touchend="onSlideGroupTouchEnd">
			<v-slide-group-item><span></span></v-slide-group-item>
			<v-slide-group-item><span></span></v-slide-group-item>
			<v-slide-group-item><span></span></v-slide-group-item>
			<v-slide-group-item :value="s.key" v-slot:default="{ isSelected, toggle }" v-for="s in slots" :key="s.key" >
				<span :class="isSelected ? 'selected' : ''" :data-slot-key="s.key" @click="toggle(); selectedSlotKey = s.key">{{ s.label }}</span>
			</v-slide-group-item>
			<v-slide-group-item><span></span></v-slide-group-item>
			<v-slide-group-item><span></span></v-slide-group-item>
			<v-slide-group-item><span></span></v-slide-group-item>

		</v-slide-group>
		<div class="centerDot"></div>
	</div>
</template>

<script>
export default {
	name: 'MonthSelector',
	props: {
		slots: {
			type: Array,
			required: true
		},
		modelValue: {
			type: String,
			default: null
		}
	},
	emits: ['update:modelValue'],
	computed: {
		selectedSlotKey: {
			get() {
				return this.modelValue;
			},
			set(value) {
				this.$emit('update:modelValue', value);
			}
		}
	},
	methods: {
		onSlideGroupUpdate(newValue) {
			// Auto-select the center item when sliding
			if (newValue && newValue !== this.selectedSlotKey) {
				this.selectedSlotKey = newValue;
			}
		},

		onSlideGroupTouchEnd() {
			// Wait a bit for the slide group to settle
			setTimeout(() => {
				this.updateSelectedFromCentre();
			}, 100);
		},

		updateSelectedFromCentre() {
			// Try to find the slide group by class
			const slideGroup = document.querySelector('.monthSlider');
			if (!slideGroup) {
				return;
			}

			const container = slideGroup.querySelector('.v-slide-group__container');
			if (!container) {
				return;
			}

			// Find the item closest to center - use span elements with data-slot-key
			const items = container.querySelectorAll('span[data-slot-key]');
			
			// Filter out empty items and get only the month/year items
			const monthItems = Array.from(items).filter(item => {
				const text = item.textContent.trim();
				return text && text.length > 0 && text !== '';
			});
			
			if (monthItems.length > 0) {
				this.findClosestItem(monthItems, container);
			}
		},

		findClosestItem(items, container) {
			let closestItem = null;
			let closestDistance = Infinity;

			items.forEach((item) => {
				const itemRect = item.getBoundingClientRect();
				const containerRect = container.getBoundingClientRect();
				const itemCenter = itemRect.left - containerRect.left + itemRect.width / 2;
				const containerCenter = containerRect.width / 2;
				const distance = Math.abs(itemCenter - containerCenter);

				if (distance < closestDistance) {
					closestDistance = distance;
					closestItem = item;
				}
			});

			// Try to get the value from the closest item
			if (closestItem) {
				const itemValue = closestItem.getAttribute('data-slot-key');
				
				// Find the matching slot directly using the value
				const matchingSlot = this.slots.find(slot => slot.key === itemValue);
				if (matchingSlot) {
					// Always snap to center, even if it's the same item
					if (matchingSlot.key !== this.selectedSlotKey) {
						this.selectedSlotKey = matchingSlot.key;
					}
					
					// Always snap to center the closest item
					this.snapToCenter(closestItem, container);
				} else {
					console.log('No matching slot found for:', itemValue);
				}
			}
		},

		snapToCenter(selectedItem, container) {
			if (!selectedItem || !container) return;
			
			// Calculate the position to center the selected item
			const itemRect = selectedItem.getBoundingClientRect();
			const containerRect = container.getBoundingClientRect();
			const itemCenter = itemRect.left - containerRect.left + itemRect.width / 2;
			const containerCenter = containerRect.width / 2;
			const scrollOffset = itemCenter - containerCenter;
			
			// Smooth scroll to center the item
			container.scrollTo({
				left: container.scrollLeft + scrollOffset,
				behavior: 'smooth'
			});
		}
	}
}
</script>

<style scoped>
.monthSelector {
	position: relative;
	margin-bottom: 15px;

	.monthSlider {
		font-size: 12px;
		span {
			margin-right: 25px;
			margin-left: 25px;
		}
		span.selected {
			color: var(--primary-color);
			font-weight: bold;
		}
	}

	.centerDot {
		position: absolute;
		bottom: -10px;
		left: 50%;
		transform: translateX(-50%);
		width: 5px;
		height: 5px;
		background-color: #413655;
		border-radius: 50%;
		z-index: 10;
	}

	.selectedDot {
		width: 7px;
	}
}
</style> 